import BaseChange from "./BaseChange"

class TravelerMoved extends BaseChange {
  constructor({ newX, newY }) {
    super()
    this.type = "travelerMoved"
    this.setMoved()
    this.setCoordinates([ newX, newY ])
  }

  messageObject() {
    if (this.character) {
      return this.character
    }
    else {
      return super.messageObject()
    }
  }

  isMoved() {
    return this.moved
  }

  setMoved() {
    this.moved = true
  }

  notMoved() {
    this.moved = false
  }

  changeTraveler(travelerName) {
    this.newTraveler = travelerName
  }

  setCharacter(character) {
    this.character = character
  }

  setCoordinates([x,y]) {
    this.newX = x
    this.newY = y
  }

  saveOldCoordinates([x,y]) {
    this.oldX = x
    this.oldY = y
  }
}
export default TravelerMoved
